import { render, staticRenderFns } from "./Hire.vue?vue&type=template&id=6830828c&scoped=true&"
import script from "./Hire.vue?vue&type=script&lang=js&"
export * from "./Hire.vue?vue&type=script&lang=js&"
import style0 from "./Hire.vue?vue&type=style&index=0&id=6830828c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6830828c",
  null
  
)

export default component.exports